/**
 * Browser → Supabase edge LLM calls (Gemini on server).
 * Use instead of direct api.groq.com from the client.
 */
import { supabase } from '../lib/supabase';

export async function invokeLlmExtract(opts: {
  prompt: string;
  text: string;
  jsonMode?: boolean;
  temperature?: number;
  maxTokens?: number;
}): Promise<string> {
  const { data, error } = await supabase.functions.invoke<{
    success?: boolean;
    content?: string;
    error?: string;
  }>('llm-extract', {
    body: {
      prompt: opts.prompt,
      text: opts.text,
      jsonMode: opts.jsonMode ?? false,
      temperature: opts.temperature ?? 0.1,
      maxTokens: opts.maxTokens ?? 2000,
    },
  });

  if (error) throw new Error(error.message || 'llm-extract request failed');
  if (!data?.success || !data.content?.trim()) {
    throw new Error(data?.error ?? 'llm-extract returned empty content');
  }
  return data.content.trim();
}
